'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Settings = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.loadSettingsWithOptionalOverride = loadSettingsWithOptionalOverride;

var _superagentBluebirdPromise = require('superagent-bluebird-promise');

var _superagentBluebirdPromise2 = _interopRequireDefault(_superagentBluebirdPromise);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _bluebird = require('bluebird');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * application settings, can be loaded from external source (json file)
 */
var Settings = exports.Settings = function () {
    function Settings(settings) {
        _classCallCheck(this, Settings);

        this.settings = setVariables(settings, {
            domain: window.location.host
        });
    }

    _createClass(Settings, [{
        key: 'get',
        value: function get(name, defaultValue) {
            _auroraJavascriptUtils.assert.string(name);

            var result = this.settings[name];

            if (result === undefined) {
                if (defaultValue === undefined) {
                    throw new Error('can\'t read settings with name ' + name);
                }

                return defaultValue;
            }

            return result;
        }
    }]);

    return Settings;
}();

var OVERRIDE_SETTINGS_PATH = '/static/override-settings.json';

/**
 * if can't load overrider settings use only defaultSettings
 * for node: get path from env, crash if file not found 
 */
function loadSettingsWithOptionalOverride(application) {
    var defaultSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : OVERRIDE_SETTINGS_PATH;
    var overrideSettings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    application.logger.info('Load settings override from \'' + path + '\'');

    if (overrideSettings) {
        return new _bluebird.Promise(function (resolve) {
            return resolve(new Settings(Object.assign(defaultSettings, overrideSettings)));
        });
    }

    var json = void 0;

    try {
        json = JSON.parse('{###JSON_CONFIG###}');
        return new _bluebird.Promise(function (resolve) {
            return resolve(new Settings(Object.assign(defaultSettings, json)));
        });
    } catch (e) {
        return _superagentBluebirdPromise2.default.get(path + '?h=' + new Date().getTime()).then(function (_ref) {
            var body = _ref.body;
            return new Settings(Object.assign(defaultSettings, body));
        }).catch(function (err) {
            console.error('can\'t load ' + path);
            return new Settings(defaultSettings);
        });
    }
}

function setVariables(config, vars) {
    function visitNode(node) {
        if (node === null || typeof node === 'undefined') {
            return node;
        }
        if (Array.isArray(node)) {
            return node.map(function (item) {
                return visitNode(item);
            });
        }
        switch (typeof node === 'undefined' ? 'undefined' : _typeof(node)) {
            case 'object':
                return Object.keys(node).reduce(function (result, key) {
                    return _extends({}, result, _defineProperty({}, key, visitNode(node[key])));
                }, {});
            case 'string':
                return Object.keys(vars).reduce(function (result, key) {
                    return result.replace(new RegExp('{{\\s*' + key + '\\s*}}'), vars[key]);
                }, node);
            default:
                return node;
        }
    }

    return visitNode(config);
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/Settings.js
// module id = 1304
// module chunks = 118